
import * as ipxRuntime$UkiDqtif6ZIm2_45Nfb2c2BnFYkxQC3SACy59wzwdnr6w from '/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$UkiDqtif6ZIm2_45Nfb2c2BnFYkxQC3SACy59wzwdnr6w, defaults: {} }
}
        